// Tipi di definizione della posizione di un assistito ("DEFINITA 100%", "70%", "50%", "STRALCIO").
export const DEF_TIPI = [
  { key: "100", label: "100%", cls: "text-emerald-950 bg-emerald-400 hover:bg-emerald-300" },
  { key: "70", label: "70%", cls: "text-amber-950 bg-amber-400 hover:bg-amber-300" },
  { key: "50", label: "50%", cls: "text-white bg-orange-600 hover:bg-orange-500" },
  { key: "stralcio", label: "Stralcio", cls: "text-white bg-red-600 hover:bg-red-500" },
];

export const defTipo = (c) => DEF_TIPI.find((t) => t.key === (c?.definita_tipo || "100")) || DEF_TIPI[0];
export const defLabel = (c) => `Definita ${defTipo(c).label}`;
